export type BaseProps = {
  operationId: number;
  wager: number;
  promotion: number;
  timeStamp: number;
  isPack?: boolean;
  classes?: string;
  isActive?: boolean;
  maxBet: number;
  maxBonus: number;
  minBet: number;
  // rollingTime?: number;
  fullRolled?: number;
  rolled?: number;
  percent?: number;
  value?: number;
};

export type Props =
  | (BaseProps & {
      isActive: true;
      rollingTime: number;
      fullRolled: number;
      rolled: number;
      percent: number;
    })
  | (BaseProps & {
      isActive?: false | undefined;
    });
export type InfoRow = {
  text: string;
  key: keyof BaseProps;
};

export enum EBonusType {
  BonusOnDeposit,
  FreeSpins,
  RakeBack,
  Battle,
  Monthly,
  Support,
  RakeBackBoost,
  Weekly,
  Retention,
  Undefined,
}

export type AdaptedBonusInfoResponse = {
  amount: number;
  bonusOdd: number;
  bonusForMinDeposit: number;
  bonusTime: number;
  wager: number;
  typeBonus: EBonusType;
};
